import { Button, Input, message } from "antd";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { LuClipboardList } from "react-icons/lu";
import API from "../../config/api";

function VcFormScreen(props: any) {
  console.log("props", props)
  let link = `${API.WEB_URL}/vc-details/${props?.data?.uuid}`;
  const copyToClipBoard = () => {
    navigator.clipboard.writeText(link).then(() => {
      message.success("Link copied");
    });
  };

  return (
    <div className="VcFormScreen-successBox">
      <div>
        <IoIosCheckmarkCircleOutline size={100} color="#17bf74" />
      </div>
      <div>
        <div
          className="VcFormScreen-text1"
          dangerouslySetInnerHTML={{
            __html: props?.successTitle || "Registration successful"
          }}
        />
        <br />
        <div
          dangerouslySetInnerHTML={{
            __html: props?.successDescription || " We look forward to seeing you at Hub71 Corporate Connect!"
          }} /> <div>

          <br />
          <Button
            type="primary"
            style={{
              fontFamily: "Roc_Grotesk_Wide",
            }}
            onClick={() => props.goBack()}
          >
            GO BACK
          </Button>
        </div>
      </div>
    </div>
  );
}

export default VcFormScreen;
